import { createApp } from "vue";
import App from "./App.vue";
import "@/config/registerServiceWorker";
import router from "@/config/router";
import store from "@/store";
import ElementPlus from "element-plus";
import "element-plus/theme-chalk/index.css";
import i18n from "./i18n";
import mitt from "mitt";
const emitter = mitt();
const app = createApp(App);
app
  .use(i18n as any)
  .use(store)
  .use(ElementPlus)
  .use(router as any);
app.provide("emitter", emitter);
app.mount("#app");
